import React from "react";
import ArtworkSEO from "./ArtworkSEO";

function PrivateSaleSEO(props) {
  return <ArtworkSEO {...props} privateSale />;
}

export default PrivateSaleSEO;
